// Kleine Hooks für die Extras-Dialoge (geplante Nachrichten, Erinnerungen, Lesezeichen, Export).
import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Stabile Referenz auf einen Handler. `Dialog` (ui.tsx) setzt den Fokus neu, sobald sich `onClose` ändert –
 * übergibt die Shell eine Inline-Funktion, würde sonst jedes Neurendern den Fokus aus Eingabefeldern ziehen.
 */
export function useStableHandler(fn: (() => void) | undefined): () => void {
  const ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useCallback(() => ref.current?.(), []);
}
